var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0C6.15995 0 2.19995 3.96 2.19995 8.8C2.19995 13.42 9.45995 20.46 10.23 21.23L11 22L11.77 21.23C12.54 20.46 19.8 13.42 19.8 8.8C19.8 3.96 15.84 0 11 0ZM11 18.92C8.57995 16.5 4.39995 11.55 4.39995 8.8C4.39995 5.17 7.36995 2.2 11 2.2C14.63 2.2 17.6 5.17 17.6 8.8C17.6 11.55 13.42 16.5 11 18.92Z",
    fill: "#6F767E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 4.39999C8.57985 4.39999 6.59985 6.38 6.59985 8.8C6.59985 11.22 8.57985 13.2 10.9999 13.2C13.4198 13.2 15.3998 11.22 15.3998 8.8C15.3998 6.38 13.4198 4.39999 10.9999 4.39999ZM10.9999 11C9.78985 11 8.79985 10.01 8.79985 8.8C8.79985 7.59 9.78985 6.6 10.9999 6.6C12.2098 6.6 13.1998 7.59 13.1998 8.8C13.1998 10.01 12.2098 11 10.9999 11Z",
    fill: "#6F767E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapicon);
export default __webpack_public_path__ + "static/media/mapicon.ed7769b393c3544e89a9747384c01ebf.svg";
export { ForwardRef as ReactComponent };